module.exports = __webpack_public_path__ + "img/page9img3.bbaf7fbe.png";